<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>{{ type === 'update' ? 'SỬA' : 'THÊM' }} KHẢO SÁT</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" flat class="pa-3">
          <h3>1. Thông tin cơ bản</h3>
          <div class="mt-4">
            <v-col cols="12" md="12" class="pa-0">
              <v-text-field
                ref="title"
                v-model="title"
                label="Tiêu đề"
                outlined
                required
                dense
                class="required"
                :rules="[$rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="pa-0">
              <DateIOSPicker
                :date.sync="deadline"
                label="Ngày kết thúc"
                dense
                outlined
                class="required"
                :rules="[$rules.required, $rules.date]"
              />
            </v-col>
            <v-col cols="12" md="12" class="pa-0 mt-6">
              <v-textarea ref="description" v-model="description" label="Mô tả" outlined required dense> </v-textarea>
            </v-col>
          </div>

          <h3>2. Đối tượng áp dụng</h3>
          <v-radio-group v-model="applyFor">
            <v-radio v-for="item in applyOptions" :key="item.value" :label="item.title" :value="item.value"></v-radio>
          </v-radio-group>
          <div v-if="applyFor === 'target'">
            <div>
              <v-chip
                class="mr-2"
                v-for="(item, index) in listTarget"
                :key="index"
                close
                @click:close="removeTarget(item.id)"
              >
                {{ item.title || '' }}
              </v-chip>
            </div>
            <v-btn class="mt-4" small depressed @click="$refs.popupChoseTarget.openDialog()">
              <v-icon left>add</v-icon>Thêm đối tượng áp dụng</v-btn
            >
          </div>
          <PopupSurveyStudentImport
            v-show="applyFor === 'specific'"
            @on-student-import="ev => (students = ev)"
            ref="excel-import"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="cancel">Đóng</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="onSave">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
    <PopupChoseTarget ref="popupChoseTarget" @onSave="addTarget" />
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import PopupChoseTarget from './PopupSurvey/PopupChoseTarget.vue'
import PopupSurveyStudentImport from './PopupSurveyStudentImport.vue'

export default {
  components: { DateIOSPicker, PopupChoseTarget, PopupSurveyStudentImport },
  data() {
    return {
      dialog: false,
      type: '',
      title: '',
      description: '',
      deadline: null,
      applyFor: 'all',
      listTarget: [],
      applyOptions: [
        { title: 'Toàn trường', value: 'all' },
        { title: 'Cấp/Khối/Lớp', value: 'target' },
        { title: 'Học sinh', value: 'specific' }
      ],
      students: []
    }
  },

  methods: {
    ...mapActions({
      fetchOne: 'survey/fetchOne',
      create: 'survey/create',
      update: 'survey/update'
    }),
    async openDialog(type = '', item) {
      if (type === 'update') {
        this.title = item.title
        this.description = item.description
        this.deadline = item.deadline
        this.applyFor = item.applyFor
        if (item.applyFor === 'target') {
          const targets = []
          targets.push(...item.academicLevels.map(i => ({ id: i.id, title: i.title, type: 'academicLevel' })))
          targets.push(...item.grades.map(i => ({ id: i.id, title: i.title, type: 'grade' })))
          targets.push(...item.classes.map(i => ({ id: i.id, title: i.title, type: 'class' })))
          this.listTarget = targets
        } else if (item.applyFor === 'specific') {
          this.students = item.students
        }
      }
      this.type = type
      this.dialog = true
      this.$nextTick(async () => {
        if (item.applyFor === 'specific') await this.$refs['excel-import'].init(item.students)
      })
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.$refs['excel-import'].reset()
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    addTarget(data) {
      this.listTarget.push(data)
    },
    removeTarget(id) {
      this.listTarget = this.listTarget.filter(item => item.id !== id)
    },
    async onSave() {
      try {
        if (this.$refs.form.validate()) {
          const isExpired = moment(this.deadline).endOf('day').isAfter(moment())
          this.$loading.active = true
          const data = {
            title: this.title,
            deadline: moment(this.deadline)
              .endOf('day')
              .toISOString(),
            description: this.description,
            applyFor: this.applyFor,
            isExpired
          }

          if (this.applyFor === 'target') {
            data.academicLevels = this.listTarget.filter(i => i.type === 'academicLevel').map(i => i.id)
            data.grades = this.listTarget.filter(i => i.type === 'grade').map(i => i.id)
            data.classes = this.listTarget.filter(i => i.type === 'class').map(i => i.id)
            data.students = null
          } else if (this.applyFor === 'specific') {
            data.students = this.students
          } else {
            data.academicLevels = null
            data.grades = null
            data.classes = null
            data.students = null
          }

          if (this.type === 'update') {
            await this.update({ id: this.$route.params.id, ...data })
            this.$alert.success('Cập nhật thành công')
            this.fetchOne(this.$route.params.id)
            return this.cancel()
          }
          const item = await this.create(data)
          this.cancel()
          this.$router.push('/survey-detail/' + item.id)
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
